import React from "react";

import convertUnit from "utils/convertUnit";

import classes from "../style.module.scss";

const DisplayRectangleInfo = ({ conversionFactor, displayUnits, rectangle }) => {
    const { height, width, perimeter, area, takeoff } = rectangle;

    const isWindow = takeoff?.takeoffField === "window";
    const outputUnit = isWindow ? (displayUnits === "ft" ? "in" : "mm") : displayUnits;

    const convertedHeight = convertUnit({
        value: height * conversionFactor,
        type: "length",
        inputUnit: "m",
        outputUnit: outputUnit,
    });

    const convertedWidth = convertUnit({
        value: width * conversionFactor,
        type: "length",
        inputUnit: "m",
        outputUnit: outputUnit,
    });

    const convertedPerimeter = convertUnit({
        value: perimeter * conversionFactor,
        type: "length",
        inputUnit: "m",
        outputUnit: outputUnit,
    });

    const convertedArea = convertUnit({
        value: area * Math.pow(conversionFactor, 2),
        type: "area",
        inputUnit: "m2",
        outputUnit: `${outputUnit}2`,
    });

    return (
        <div className={classes.componentInfo}>
            <h5 className={classes.componentTitle}>Rectangle - {rectangle.name}</h5>
            <div>
                <span className={classes.label}>Width:</span>{" "}
                <span className={classes.value}>
                    {convertedWidth.toFixed(4)} {outputUnit}
                </span>
            </div>
            <div>
                <span className={classes.label}>Height:</span>{" "}
                <span className={classes.value}>
                    {convertedHeight.toFixed(4)} {outputUnit}
                </span>
            </div>
            <div>
                <span className={classes.label}>Perimeter:</span>{" "}
                <span className={classes.value}>
                    {convertedPerimeter.toFixed(4)} {outputUnit}
                </span>
            </div>
            <div>
                <span className={classes.label}>Area:</span>{" "}
                <span className={classes.value}>
                    {convertedArea.toFixed(4)} {outputUnit}&sup2;
                </span>
            </div>
        </div>
    );
};

export default DisplayRectangleInfo;
